import React from 'react';
import { observer } from "mobx-react-lite";
import { StringActionDetail } from './components/StringActionDetail';
import { useTranslation } from 'react-i18next';
export const CopyAwarenessIntoVariableDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.new_variable"),
    value: action.name,
    valueSetter: action.setName.bind(action),
    allowBlankValue: false
  });
});